import React, { useState } from "react";
import { Link } from "gatsby";
import { navigate } from "gatsby";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import MenuList from "./MenuList";
import { normalizeUrl } from "./utils";

const MenuListItem = ({ item, isFooter = false }) => {
  const [seeChildrens, setSeeChildrens] = useState(false);
  const normalizedUrl = normalizeUrl(item.url);

  const mouseEnter = () => {
    setSeeChildrens(true);
  };

  const mouseLeave = () => {
    setSeeChildrens(false);
  };

  if (item.children.length === 0) {
    return (
      <li onClick={() => navigate(normalizedUrl)}>
        <span>
          <Link to={normalizedUrl}>{item.label}</Link>
        </span>
      </li>
    );
  }

  return (
    <li onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
      <span className="li-parent">
        <Link to={normalizedUrl}>{item.label}</Link>
        {!isFooter && (
          <ChevronDownIcon
            style={{
              width: "16px",
              opacity: seeChildrens ? 1 : 0.6,
              transition: "opacity 0.3s ease",
            }}
          />
        )}
      </span>
      <ul
        className={`child-menu ${seeChildrens ? "show" : ""} ${
          item.children.length > 4 ? "has-many-items" : ""
        }`}
      >
        <MenuList nodes={item.children} />
      </ul>
    </li>
  );
};

export default MenuListItem;
